import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getDownloadLink } from '../Common/ContainerAppDownloader';
import Icon from '@projeccions-pdc/react-icon';
import styles from './ToolsStyle';
import LocalizedStrings from '../Localization/localization';


class DownloadAppTool extends Component {
    handleDownloadApp = (link) => {
        if (link !== undefined) {
            window.open(link, '_blank');
        }
    }

    render() {
        let iconElement = <Icon name='md-file-download' size={this.props.iconSize} primaryColor={'#fff'} />;
        let color = '#F44336';
        let title = LocalizedStrings.downloadApp;
        let link = getDownloadLink();
        // let description = link !== undefined ?
        //     `${LocalizedStrings.downloadAppFor} ${getPlatform()}`
        //     : LocalizedStrings.noAppAvailable;
        if (process.env.REACT_APP_IS_CONTAINER !== 'true') {
            // if (this.props.smartphoneView === true) {
            //     return (
            //         <div data-id={this.props['data-id']} data-type={this.props['data-type']} style={styles.toolsItemSmartphone} onClick={() => this.handleDownloadApp(link)}>
            //             <div style={{ ...(styles.toolAvatarSmartphone), backgroundColor: color }}>
            //                 {iconElement}
            //                 {'  '}
            //                 {title}
            //             </div>
            //             <div style={styles.description}>{description}</div>
            //         </div>
            //     );
            // } else {
            return (
                <div data-id={this.props['data-id']} data-type={this.props['data-type']} style={styles.toolsItem} onClick={() => this.handleDownloadApp(link)}>
                    <div style={{ ...(styles.toolAvatar), backgroundColor: color }}>
                        {iconElement}
                        {/* <div style={styles.toolTitle}>{title}</div> */}
                    </div>
                    <div style={styles.description}>{title}</div>
                </div>
            );
            // }
        } else {
            return <span />;
        }
    }
}
DownloadAppTool.propTypes = {
    smartphoneView: PropTypes.bool,
    iconSize: PropTypes.string.isRequired,
    'data-id': PropTypes.string,
    'data-type': PropTypes.string,
};

export default DownloadAppTool;